<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('Products')" class="mt-6">
            <products></products>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Products from "./Products.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
    name: "saleManagement_MyContracts_Management_Index",
  components: {
    Products,
  },
};
</script>
